// import React, { useState } from "react";
// import ReactQuill from "react-quill";
// import "react-quill/dist/quill.snow.css";

// // Custom toolbar modules including image
// const modules = {
//   toolbar: {
//     container: [
//       [{ 'header': '1' }, { 'header': '2' }, { 'font': [] }],
//       [{ size: [] }],
//       ['bold', 'italic', 'underline', 'strike', 'blockquote'],
//       [{ 'list': 'ordered' }, { 'list': 'bullet' }, { 'indent': '-1' }, { 'indent': '+1' }],
//       ['link', 'image'],  // Added image button
//       [{ 'code-block': true }],
//       ['clean']
//     ],
//     handlers: {
//       image: imageHandler // Custom image handler
//     }
//   },
//   clipboard: {
//     matchVisual: false,
//   }
// };

// // Supported formats including image
// const formats = [
//   'header', 'font', 'size',
//   'bold', 'italic', 'underline', 'strike', 'blockquote',
//   'list', 'bullet', 'indent',
//   'link', 'image',  // Added image format
//   'code-block'
// ];

// // Function to handle image uploads
// function imageHandler() {
//   const input = document.createElement("input");
//   input.setAttribute("type", "file");
//   input.setAttribute("accept", "image/*");
//   input.click();

//   input.onchange = async () => {
//     const file = input.files[0];
//     if (file) {
//       const reader = new FileReader();
//       reader.onload = () => {
//         const quill = this.quill;
//         const range = quill.getSelection();
//         quill.insertEmbed(range.index, "image", reader.result);
//       };
//       reader.readAsDataURL(file);
//     }
//   };
// }

// const TextRichEditor = ({ value, onChange, placeholder }) => {
//   return (
//     <ReactQuill
//       theme="snow"
//       value={value}
//       onChange={onChange}
//       placeholder={placeholder}
//       modules={modules}  // Pass the custom toolbar modules
//       formats={formats}  // Pass the supported formats
//     />
//   );
// };

// export default TextRichEditor;

import React, { useState } from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";
import { PostRegisterData } from "store/shop/shop";
import * as url from "../../store/constant/Endpoints";
// Custom toolbar modules including image
const modules = {
  toolbar: {
    container: [
      [{ 'header': '1' }, { 'header': '2' }, { 'font': [] }],
      [{ size: [] }],
      ['bold', 'italic', 'underline', 'strike', 'blockquote'],
      [{ 'list': 'ordered' }, { 'list': 'bullet' }, { 'indent': '-1' }, { 'indent': '+1' }],
      ['link', 'image'],  // Added image button
      [{ 'code-block': true }],
      ['clean']
    ],
    handlers: {
      image: imageHandler
    }
  },
  clipboard: {
    matchVisual: false,
  }
};
// Supported formats including image
const formats = [
  'header', 'font', 'size',
  'bold', 'italic', 'underline', 'strike', 'blockquote',
  'list', 'bullet', 'indent',
  'link', 'image',  // Added image format
  'code-block'
];
// Function to handle image uploads
function imageHandler() {
  const input = document.createElement("input");
  input.setAttribute("type", "file");
  input.setAttribute("accept", "image/*");
  input.click();
  input.onchange = async () => {
    const file = input.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = async () => {
        const quill = this.quill;
        const range = quill.getSelection();
        const formData = new FormData();
        formData.append('file', file)
        formData.append('header_type', 'IMAGE')
        const response = await PostRegisterData(url.editorApi_url + 'file/upload', formData)
        quill.insertEmbed(range.index, "image", response.data.path);
      };
      reader.readAsDataURL(file);
    }
  };
}
const TextRichEditor = ({ value, onChange, placeholder }) => {
  return (
    <ReactQuill
      theme="snow"
      value={value}
      onChange={onChange}
      placeholder={placeholder}
      modules={modules}  // Pass the custom toolbar modules
      formats={formats}  // Pass the supported formats
    />
  );
};
export default TextRichEditor;